var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme-tabs"},[_c('ul',{staticClass:"tab-heads"},_vm._l((_vm.tabs),function(tab){return _c('li',{staticClass:"tab-label",class:{ 'active': tab.isShow },on:{"click":function($event){return _vm.selectTab(tab)}}},[_vm._v("\n        "+_vm._s(tab.name)+"\n    ")])}),0),_vm._v(" "),_c('div',{staticClass:"tab-body"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eb87966","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shell/components/tabs/ThemeTabs.vue
// module id = 256
// module chunks = 0